import { DiaryEntryDto } from '@app/models/dtos/contentDto';

const BUCKET = 'https://nabinkawan.github.io/bucket/portfolio/images/diary';

/**
 * The diary, newest first.
 *
 * ── Adding a photo ────────────────────────────────────────────────────────
 * 1. Commit the image to the `nabinkawan/bucket` repo under
 *    `portfolio/images/diary/`, around 1600px on the long side and under
 *    ~400 KB. That repo is what serves https://nabinkawan.github.io/bucket/...
 * 2. Add an entry at the top of the array with its real pixel width/height,
 *    so the frame reserves the right space and nothing jumps on load.
 * 3. GitHub Pages takes about a minute to publish the new file.
 *
 * ── Adding a video ────────────────────────────────────────────────────────
 * Upload to YouTube, then add:
 *   { id: 'late-night', type: 'youtube', videoId: 'abc123XYZ',
 *     title: 'Shipping at 2am', place: 'Home, Bhaktapur',
 *     date: '2026-09', caption: 'One of those nights.' }
 *
 * `date` is `YYYY-MM-DD` and renders as "6 September".
 */
const diary: DiaryEntryDto[] = [
    {
        id: 'bhajya-pukhu',
        type: 'photo',
        src: `${BUCKET}/bhajya-pukhu.jpg`,
        width: 1200,
        height: 1600,
        alt: 'A laptop open on a balcony rail, looking out over greenery and a pond',
        place: 'Bhajya Pukhu, Bhaktapur',
        date: '2026-08-26',
        caption: 'A quiet corner of Bhajya Pukhu.',
        icon: 'plant',
        wide: true
    },
    {
        id: 'hill-with-a-book',
        type: 'photo',
        src: `${BUCKET}/hill-with-a-book.jpg`,
        width: 1200,
        height: 1600,
        alt: 'Holding a copy of Atomic Habits on a grassy hillside looking over a green valley',
        place: 'Suryabinayak, Bhaktapur',
        date: '2026-07-26',
        caption: 'Took the book up the hill instead of the laptop. Rare.',
        wide: true
    },
    {
        id: 'blue-wall-desk',
        type: 'photo',
        src: `${BUCKET}/blue-wall-desk.jpg`,
        width: 1200,
        height: 1600,
        alt: 'A MacBook and split keyboard on a wooden desk beside a window, against a blue wall with a potted palm',
        place: 'Bhaktapur, Nepal',
        date: '2026-07-24',
        caption: 'Morning light, blue wall, split keyboard.'
    },
    {
        id: 'library-lap',
        type: 'photo',
        src: `${BUCKET}/library-lap.jpg`,
        width: 1200,
        height: 1600,
        alt: 'A laptop balanced on knees in front of wooden library shelves full of books',
        place: 'Itachhen, Bhaktapur',
        date: '2026-06-25',
        caption: 'A library instead of a café. Quiet, free, and nobody asks whether you want another coffee.'
    },
    {
        id: 'nursery-cafe',
        type: 'photo',
        src: `${BUCKET}/nursery-cafe.jpg`,
        width: 1200,
        height: 1600,
        alt: 'A laptop and an e-reader showing the Refactoring book on a live-edge table, surrounded by potted plants and terracotta pots',
        place: 'Lalitpur, Nepal',
        date: '2026-03-13',
        caption: 'Reading, coding, and watching the plants.'
    },
    {
        id: 'bug-triage-coffee',
        type: 'photo',
        src: `${BUCKET}/bug-triage-coffee.jpg`,
        width: 1200,
        height: 1600,
        alt: 'A laptop showing a bug tracker board beside a glass cup of black coffee on a wooden café table',
        place: 'Kamal Binayak, Bhaktapur',
        date: '2026-02-25',
        caption: 'Bug triage goes down easier with black coffee.'
    },
    {
        id: 'cafe-dog',
        type: 'photo',
        src: `${BUCKET}/cafe-dog.jpg`,
        width: 1200,
        height: 1600,
        alt: 'A dog asleep on a café bench right beside an open laptop on a wooden table',
        place: 'Lakeside, Pokhara',
        date: '2026-01-20',
        caption: 'My coding companion for the afternoon.',
        timeOfDay: 'evening'
    },
    {
        id: 'wild-honey-migration',
        type: 'photo',
        src: `${BUCKET}/wild-honey-migration.jpg`,
        width: 1200,
        height: 1600,
        alt: 'A laptop showing a database migration, in a café with wooden benches and warm pendant lights',
        place: 'Lakeside, Pokhara',
        date: '2026-01-20',
        caption: 'A little coding before breakfast.',
        timeOfDay: 'morning'
    },
    {
        id: 'pokhara-first-morning',
        type: 'photo',
        src: `${BUCKET}/pokhara-first-morning.jpg`,
        width: 1200,
        height: 1600,
        alt: 'A laptop on a sunlit café terrace, terminal open, with shopfronts across the street',
        place: 'Lakeside, Pokhara',
        date: '2026-01-19',
        caption: 'First morning in Pokhara.',
        wide: true
    }
];

export default diary;
